import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Seo } from "@/components/common/Seo";
import { PAGES, IMAGES, SEO } from "@/content/site";

export default function About() {
  const p = PAGES.about;
  return (
    <div data-testid="page-about">
      <Seo title={SEO.about.t} description={SEO.about.d} path="/about" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.contractSign} />
      <section className="container-x py-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7 space-y-12">
            {p.sections.map((s, idx) => (
              <Reveal key={s.heading} delay={idx * 0.05}>
                <h2 className="text-2xl font-semibold text-ink-heading">{s.heading}</h2>
                <p className="mt-3 text-base leading-relaxed text-ink-body">{s.body}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl sticky top-28">
              <img src={IMAGES.portDusk} alt="International port at dusk" className="h-[480px] w-full object-cover" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
